var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 7,
    width: 34,
    height: 34,
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4839 23.1936C41.4839 23.1936 36.7928 26.4401 29.9678 26.5807V37.8275C29.9677 39.6485 30.3741 41.4465 31.1572 43.0904C31.9404 44.7343 33.0805 46.1828 34.4946 47.33L41.4839 53L48.4731 47.33C49.8872 46.1828 51.0274 44.7343 51.8106 43.0904C52.5937 41.4465 53.0001 39.6485 53 37.8275V26.5807C46.175 26.4401 41.4839 23.1936 41.4839 23.1936Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5162 34.7095V30.645H39.4517V34.7095H35.3872V38.774H39.4517V42.8385H43.5162V38.774H47.5807V34.7095H43.5162Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1934 30.645H29.9675",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1934 36.0645H29.9675",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5315 41.4839H23.1934",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4513 31.3226C18.8255 31.3226 19.1288 31.0193 19.1288 30.6452C19.1288 30.2711 18.8255 29.9678 18.4513 29.9678C18.0772 29.9678 17.7739 30.2711 17.7739 30.6452C17.7739 31.0193 18.0772 31.3226 18.4513 31.3226Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4513 36.7418C18.8255 36.7418 19.1288 36.4385 19.1288 36.0644C19.1288 35.6903 18.8255 35.387 18.4513 35.387C18.0772 35.387 17.7739 35.6903 17.7739 36.0644C17.7739 36.4385 18.0772 36.7418 18.4513 36.7418Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4513 42.1612C18.8255 42.1612 19.1288 41.8579 19.1288 41.4838C19.1288 41.1097 18.8255 40.8064 18.4513 40.8064C18.0772 40.8064 17.7739 41.1097 17.7739 41.4838C17.7739 41.8579 18.0772 42.1612 18.4513 42.1612Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3868 19.129V16.4193C35.3868 15.8804 35.1727 15.3634 34.7916 14.9823C34.4104 14.6012 33.8935 14.3871 33.3545 14.3871H31.9997V11H21.161V14.3871H19.8062C19.2672 14.3871 18.7503 14.6012 18.3692 14.9823C17.988 15.3634 17.7739 15.8804 17.7739 16.4193V19.129H35.3868Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5483 15.0645V15.7419H28.6128V15.0645",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3871 53H12.3548C11.9955 53 11.6509 52.8573 11.3968 52.6032C11.1427 52.3491 11 52.0045 11 51.6452V17.7743C11 17.4149 11.1427 17.0703 11.3968 16.8163C11.6509 16.5622 11.9955 16.4194 12.3548 16.4194H13.7097",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3872 16.4194H40.1291C40.4885 16.4194 40.8331 16.5622 41.0872 16.8163C41.3412 17.0703 41.484 17.4149 41.484 17.7743V18.4517",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5216_61567",
    transform: "scale(0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5216_61567",
    width: 28,
    height: 28,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.011c78c73cbcb1315b405d9d0b908364.svg";
export { ForwardRef as ReactComponent };